// import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import { Result, Space, Typography } from 'antd';
import LIEnquirySubmittedIcon from 'assets/images/support/lienquiry-submitted-icon.svg';

// import { useEnquiryEmailSubmission } from 'all-in-one-shared-api';
import { PrimaryButton } from 'components';
// import { useKeycloakReady } from 'hooks/useKeycloakReady';

interface EnquiryData {
  enquiryReference: string;
}

export const EnquirySuccessPage = ({ enquiryReference }: EnquiryData) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!enquiryReference) {
    return <Navigate to="/notFound" replace={true} />;
  }

  return (
    <Result
      icon={<img style={{ width: '153px', height: '153px' }} src={LIEnquirySubmittedIcon} />}
      extra={
        <Space direction="vertical">
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px' }}>
            {t('life.enquiry.success.message')}
          </Typography.Text>
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            {t('life.enquiry.toastDsc')}
          </Typography.Text>
          <PrimaryButton
            className="sucsesPrimaryButton"
            style={{ height: '56px', fontFamily: 'Roboto500', fontSize: '20px' }}
            onClick={() => navigate('/LIHome')}
          >
            {t('common.done')}
          </PrimaryButton>
        </Space>
      }
    />
  );
};
